import React from "react";
import { VideoBlockViewModel } from "./VideoBlockViewModel.csharp";
import { VideoContainer } from "../../../Components/VideoContainer/VideoContainer";

export const VideoBlock: React.FC<VideoBlockViewModel> = ({
  body,
  videoUrl,
  altDescription,
  transcription,
}) => {
  if (!videoUrl) return null;

  return (
    <VideoContainer
      body={body}
      altDescription={altDescription}
      transcription={transcription}
    >
      <video controls>
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </VideoContainer>
  );
};
